import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { currentUserInfo } from 'atoms';

const MenuItem = () => {
  const {
    apt: { domain },
  } = useRecoilValue(currentUserInfo);

  return (
    <Container>
      <MenuItemContainer className='pl-3 d-flex flex-row align-items-center'>
        <MenuLink
          className='w-100 position-relative d-flex flex-row align-items-center'
          to={'modify'}
        >
          <MenuIconLeft className='i-mypage-info' />
          <MenuText className='px-2'>내 정보 수정</MenuText>
          <MenuIconRight className='i-chevronRight position-absolute' />
        </MenuLink>
      </MenuItemContainer>
      <MenuItemContainer className='pl-3 d-flex flex-row align-items-center'>
        <MenuLink
          className='w-100 position-relative d-flex flex-row align-items-center'
          to={'password/reset'}
        >
          <MenuIconLeft className='i-mypage-pw' />
          <MenuText className='px-2'>비밀번호 재설정</MenuText>
          <MenuIconRight className='i-chevronRight position-absolute' />
        </MenuLink>
      </MenuItemContainer>
      <MenuItemContainer className='pl-3 d-flex flex-row align-items-center'>
        <MenuAnchor
          className='w-100 position-relative d-flex flex-row align-items-center'
          href={`https://m.${domain}/?pageName=dashboard&codeSeq=bill`}
        >
          <MenuIconLeft className='i-mypage-bill' />
          <MenuText className='px-2'>월별관리비고지서</MenuText>
          <MenuIconRight className='i-chevronRight position-absolute' />
        </MenuAnchor>
      </MenuItemContainer>
    </Container>
  );
};

const Container = styled.section``;
const MenuItemContainer = styled.article`
  height: 54px;
`;
const MenuIconLeft = styled.i``;
const MenuIconRight = styled.i`
  right: 17px;
`;
const MenuText = styled.span``;
const MenuLink = styled(Link)``;
const MenuAnchor = styled.a``;

export default MenuItem;
